
import { useMemo, useState } from "react";
import {
  MenuItem, FormControl, InputLabel, Select, Pagination, Stack, Typography // , ToggleButtonGroup, ToggleButton
} from "@mui/material";
import type {SelectChangeEvent} from "@mui/material";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";


import ClubCard from "./ClubCardModern";
import type { UniClub as Club } from "../types";

// type SortKey = "nom";
// type SortKey = "name" | "city" | "postalCode";

interface Props {
  clubs: Club[];
}

export default function ClubsList({ clubs }: Props) {
  // --- UI state
  const [query, setQuery] = useState("");
  const [city, setCity] = useState<string>("");
//   const [federation, setFederation] = useState<string>("");
//   const [level, setLevel] = useState<string>("");
//   const [sortKey, setSortKey] = useState<SortKey>("nom");
//   const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");
  const [page, setPage] = useState(1);
  const pageSize = 12;

//   // --- Derived lists for filters
//   const cities = useMemo(
//     () => Array.from(new Set(clubs.map(c => c.city))).sort((a, b) => a.localeCompare(b)),
//     [clubs]
//   );
  // --- Derived lists for filters
  const cities = useMemo(
    () => Array.from(new Set(clubs.map(c => c.lieu))).sort((a, b) => a.localeCompare(b)),
    [clubs]
  );

//   const federations = useMemo(
//     () => Array.from(new Set(clubs.map(c => c.federation).filter(Boolean))) as string[],
//     [clubs]
//   );

//   const levels = ["Débutant", "Intermédiaire", "Avancé"];

  // --- Filtering
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return clubs.filter(c => {
      const matchesQuery =
        !q ||
        c.nom.toLowerCase().includes(q) ||
        c.lieu.toLowerCase().includes(q);

      const matchesCity = !city || c.lieu === city;
    //   const matchesFederation = !federation || c.federation === federation;
    //   const matchesLevel = !level || (c.levels ?? []).includes(level as any);

      return matchesQuery && matchesCity; // && matchesFederation && matchesLevel;
    });
  }, [clubs, query, city]); //, federation, level

//   // --- Sorting
//   const sorted = useMemo(() => {
//     const s = [...filtered].sort((a, b) => {
//       const va = String(a[sortKey] ?? "");
//       const vb = String(b[sortKey] ?? "");
//       const cmp = va.localeCompare(vb, "fr", { numeric: true, sensitivity: "base" });
//       return cmp; //sortDir === "asc" ? cmp : -cmp;
//     });
//     return s;
//   }, [filtered]); // , sortKey, sortDir

  // --- Pagination
  const pageCount = Math.max(1, Math.ceil(filtered.length / pageSize));
  const current = filtered.slice((page - 1) * pageSize, page * pageSize);
//   // --- Handlers
//   const handleSortKey = (_: React.MouseEvent<HTMLElement>, value: SortKey | null) => {
//     if (value) setSortKey(value);
//   };
//   const handleSortDir = (_: React.MouseEvent<HTMLElement>, value: "asc" | "desc" | null) => {
//     if (value) setSortDir(value);
//   };
  const handleCity = (e: SelectChangeEvent) => setCity(e.target.value);
//   const handleFederation = (e: SelectChangeEvent) => setFederation(e.target.value);
//   const handleLevel = (e: SelectChangeEvent) => setLevel(e.target.value);

  // Reset page when filters change
  const resetPage = () => setPage(1);

  return (
    <Stack spacing={3}>
      {/* Barre de recherche et filtres */}
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <TextField
            fullWidth
            label="Recherche (nom, ville, code postal)"
            value={query}
            onChange={(e) => { setQuery(e.target.value); resetPage(); }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Ville</InputLabel>
            <Select label="Ville" value={city} onChange={(e) => { handleCity(e); resetPage(); }}>
              <MenuItem value=""><em>Toutes</em></MenuItem>
              {cities.map((v) => (
                <MenuItem key={v} value={v}>{v}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid size={{ xs: 12, sm: 6, md: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Fédération</InputLabel>
            <Select label="Fédération" value={federation} onChange={(e) => { handleFederation(e); resetPage(); }}>
              <MenuItem value=""><em>Toutes</em></MenuItem>
              {federations.map((f) => (
                <MenuItem key={f} value={f}>{f}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        {/* <Grid size={{ xs: 12, sm: 6, md: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Niveau</InputLabel>
            <Select label="Niveau" value={level} onChange={(e) => { handleLevel(e); resetPage(); }}>
              <MenuItem value=""><em>Tous</em></MenuItem>
              {levels.map((l) => (
                <MenuItem key={l} value={l}>{l}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        {/* <Grid size={{ xs: 12, md: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <ToggleButtonGroup
              size="small"
              value={sortKey}
              exclusive
              onChange={handleSortKey}
              aria-label="Champ de tri"
            >
              <ToggleButton value="name">Nom</ToggleButton>
              <ToggleButton value="city">Ville</ToggleButton>
              <ToggleButton value="postalCode">CP</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup
              size="small"
              value={sortDir}
              exclusive
              onChange={handleSortDir}
              aria-label="Direction du tri"
            >
              <ToggleButton value="asc">↑</ToggleButton>
              <ToggleButton value="desc">↓</ToggleButton>
            </ToggleButtonGroup>
          </Stack>
        </Grid> */}
      </Grid>

      {/* Résultats */}
      {filtered.length === 0 ? (
        <Typography variant="body1">Aucun club ne correspond aux critères.</Typography>
      ) : (
        <>
          <Grid container spacing={2}>
            {current.map((club) => (
              <Grid key={club.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <ClubCard club={club} />
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="center">
            <Pagination
              count={pageCount}
              page={page}
              onChange={(_, value) => setPage(value)}
              color="primary"
              shape="rounded"
            />
          </Box>
        </>
      )}
    </Stack>
  );
}
